module.exports = __webpack_public_path__ + "static/media/17.23f17bd0.jpg";